// Knowledge hub tabs. Standalone module (no React) so the breadcrumb title map
// and the routes can import it without pulling in the tab pages.

export const KNOWLEDGE_BASE_PATH = "/app/knowledge"

export type KnowledgeTab = "library" | "company-profile" | "templates" | "prompts"

export interface KnowledgeTabDefinition {
  id: KnowledgeTab
  label: string
}

/** Rendered in this order in the underline sub-nav. The first is the default. */
export const KNOWLEDGE_TABS: KnowledgeTabDefinition[] = [
  { id: "library", label: "Library" },
  { id: "company-profile", label: "Company profile" },
  { id: "templates", label: "Templates" },
  { id: "prompts", label: "Saved prompts" },
]

export const DEFAULT_KNOWLEDGE_TAB: KnowledgeTab = "library"

export function isKnowledgeTab(value: string | undefined): value is KnowledgeTab {
  return KNOWLEDGE_TABS.some((tab) => tab.id === value)
}

export function knowledgeTabPath(tab: KnowledgeTab): string {
  return `${KNOWLEDGE_BASE_PATH}/${tab}`
}
